import { Routes } from '@angular/router';
import { DownloadComponent } from './components/download/download.component';
import { TransferExpiredComponent } from './components/transfer-expired/transfer-expired.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { UploadComponent } from './components/upload/upload.component';
import { CheckDomainComponent } from './components/check-domain/check-domain.component';
import { UploadLinkExpiredComponent } from './components/upload-link-expired/upload-link-expired.component';

export const routes: Routes = [
  {
    path: '',
    component: DownloadComponent
  },
  {
    path: 'upload/:id',
    component: UploadComponent
  },
  {
    path: 'check-domain',
    component: CheckDomainComponent
  },
  {
    path: 'transfer-expired',
    component: TransferExpiredComponent
  },
  {
    path: 'upload-link-expired',
    component: UploadLinkExpiredComponent
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  }
];
